<template>
  <div class="app-container">    
    <el-card class="box-card">
      <div class="filter-container">
        <el-form :model="queryParams" ref="queryForm" :inline="true" >
          <el-form-item label="运营商名称" prop="distributorId">
            <el-select 
              v-model="queryParams.distributorId" 
              placeholder="请选择运营商" 
              clearable 
              filterable
              size="small"
              @change="handleDistributorChange"
            >
              <el-option
                v-for="item in distributorList"
                :key="item.id"
                :label="item.name"
                :value="item.id"
              />
            </el-select>
          </el-form-item>
          <el-form-item label="是否启用微信分账" prop="isActive">
            <el-select v-model="queryParams.isActive" placeholder="请选择是否启用微信分账" clearable size="small">
              <el-option
                v-for="dict in sysYesNoDict"
                :key="dict.value"
                :label="dict.label"
                :value="dict.value"
              />
            </el-select>
          </el-form-item>
          <el-form-item label="是否默认" prop="isDefault">
            <el-select v-model="queryParams.isDefault" placeholder="请选择是否默认" clearable size="small">
              <el-option
                v-for="dict in sysYesNoDict"
                :key="dict.value"
                :label="dict.label"
                :value="dict.value"
              />
            </el-select>
          </el-form-item>
          <el-form-item>
            <el-button type="primary" icon="el-icon-search" size="mini" @click="handleQuery">搜索</el-button>
          </el-form-item>
           <el-form-item>
            <el-button  v-if="isSuperAuthority"
            type="primary"
            icon="el-icon-plus"
            size="mini"
            @click="handleAdd"
            v-hasPermi="['distributor:merchantPaymentConfig:add']"
            style="background-color: #3CA757; border-color: #3CA757;"
          >新增</el-button>
          </el-form-item>
        </el-form>
      </div>

      <el-table v-loading="loading" :data="merchantPaymentConfigList" @selection-change="handleSelectionChange" border stripe>
      <el-table-column type="selection" width="55" align="center" />
      <el-table-column label="序号" type="index" align="center"/>
      <el-table-column label="运营商名称" align="center" prop="distributorName" />
      <el-table-column label="关联服务商" align="center" prop="spConfigName">
        <template slot-scope="scope">
          <span>{{ scope.row.spConfigName || '默认' }}</span>
        </template>
      </el-table-column>
      <el-table-column label="微信小程序AppID" align="center" prop="appId" />
      <el-table-column label="微信支付商户号" align="center" prop="mchId" />
      <el-table-column label="是否启用银联支付" align="center" prop="unionPayEnabled">
        <template slot-scope="scope">
          <span :style="{ color: scope.row.unionPayEnabled === 1 ? '#67C23A' : '#909399' }">{{ scope.row.unionPayEnabled === 1 ? '是' : '否' }}</span>
        </template>
      </el-table-column>
      <el-table-column label="是否启用微信分账" align="center" prop="isActive" >
        <template slot-scope="scope">
          <span :style="{ color: scope.row.isActive === 1 ? '#67C23A' : '#F56C6C' }">{{ scope.row.isActive === 1 ? '是' : '否' }}</span>
        </template>
      </el-table-column>
      <el-table-column label="是否默认" align="center" prop="isDefault">
        <template slot-scope="scope">
          <span :style="{ color: scope.row.isDefault === 1 ? '#67C23A' : '#F56C6C' }">{{ scope.row.isDefault === 1 ? '是' : '否' }}</span>
        </template>
      </el-table-column>
      <el-table-column label="创建时间" align="center" prop="createTime" width="160px">
        <template slot-scope="scope">
          <span>{{ scope.row.createTime }}</span>
        </template>
      </el-table-column>
      <el-table-column label="操作" align="center" class-name="small-padding fixed-width" width="260px">
        <template slot-scope="scope">
          <el-button
            size="mini"
            type="primary"
            icon="el-icon-view"
            @click="handleDetail(scope.row)"
            v-hasPermi="['distributor:merchantPaymentConfig:query']"
          >详情</el-button>
          <el-button v-if="isSuperAuthority"
            size="mini"
            type="primary"
            icon="el-icon-edit"
            @click="handleUpdate(scope.row)"
            v-hasPermi="['distributor:merchantPaymentConfig:edit']"
          >修改</el-button>
          <el-button
            size="mini"
            type="warning"
            icon="el-icon-setting"
            @click="handleQuerySplitRatio(scope.row)"
          >分账比例</el-button>
        </template>
      </el-table-column>
    </el-table>
    
      <div class="pagination-container">
        <el-pagination
          @size-change="handleSizeChange"
          @current-change="handleCurrentChange"
          :current-page="queryParams.page"
          :page-sizes="[10, 20, 30, 50]"
          :page-size="queryParams.limit"
          layout="total, sizes, prev, pager, next, jumper"
          :total="total"
        >
        </el-pagination>
      </div>
    </el-card>

    <!-- 添加或修改商户支付配置对话框 -->
    <el-dialog :title="title" :visible.sync="open" width="750px" append-to-body @close="handleDialogClose">
      <el-form ref="form" :model="form" :rules="rules" label-width="150px">
        <el-form-item label="运营商名称" prop="distributorId">
          <el-select 
            v-model="form.distributorId" 
            clearable
            filterable
            placeholder="请选择运营商" 
            @change="handleFormDistributorChange"
            :disabled="!!form.id"
          >
            <el-option
              v-for="item in distributorList"
              :key="item.id"
              :label="item.name"
              :value="item.id"
            />
          </el-select>
        </el-form-item>
        <el-form-item label="关联服务商" prop="spConfigId">
          <el-select 
            v-model="form.spConfigId" 
            clearable
            filterable
            placeholder="请选择服务商（不选则使用默认）" 
          >
            <el-option
              v-for="item in spConfigList"
              :key="item.id"
              :label="item.spName + ' (' + item.spMchId + ')'"
              :value="item.id"
            />
          </el-select>
        </el-form-item>

        <!-- 微信支付配置 -->
        <el-divider content-position="left">微信支付配置</el-divider>
        
        <el-form-item label="微信小程序AppID" prop="appId">
          <el-input v-model="form.appId" placeholder="请输入微信小程序AppID" />
        </el-form-item>
        <el-form-item label="微信支付商户号" prop="mchId">
          <el-input v-model="form.mchId" placeholder="请输入微信支付商户号" />
        </el-form-item>
        <el-form-item label="微信支付密钥地址" prop="privateKeyFromPath">
          <el-input v-model="form.privateKeyFromPath" placeholder="请输入微信支付密钥地址 apiclient_key.pem 文件地址" />
        </el-form-item>
        <el-form-item label="微信支付证书序列号" prop="merchantSerialNumber">
          <el-input v-model="form.merchantSerialNumber" placeholder="请输入微信支付证书序列号" />
        </el-form-item>
        <el-form-item label="微信支付证书路径" prop="certPath">
          <el-input v-model="form.certPath" placeholder="请输入微信支付证书路径" />
        </el-form-item>
        <el-form-item label="微信支付回调地址" prop="notifyUrl">
          <el-input v-model="form.notifyUrl" placeholder="请输入微信支付回调地址" />
        </el-form-item>
        <el-form-item label="微信退款回调地址" prop="refundUrl">
          <el-input v-model="form.refundUrl" placeholder="请输入微信退款回调地址" />
        </el-form-item>
        <el-form-item label="APIv3密钥" prop="apiV3Key">
          <el-input v-model="form.apiV3Key" type="password" placeholder="请输入APIv3密钥" show-password />
        </el-form-item>
        <el-form-item label="APIv2密钥" prop="apiV2Key">
          <el-input v-model="form.apiV2Key" type="password" placeholder="请输入APIv2密钥，微信支付分前端调起签名使用" show-password />
        </el-form-item>
        <el-form-item label="支付分服务ID" prop="wechatPayScoreServiceId">
          <el-input v-model="form.wechatPayScoreServiceId" placeholder="请输入微信支付分服务ID" />
        </el-form-item>

        <!-- 银联支付配置 -->
        <el-divider content-position="left">银联支付配置</el-divider>
        
        <el-form-item label="是否启用银联支付" prop="unionPayEnabled">
          <el-radio-group v-model="form.unionPayEnabled" @change="handleUnionPayChange">
            <el-radio :label="1">启用</el-radio>
            <el-radio :label="0">禁用</el-radio>
          </el-radio-group>
        </el-form-item>
        <el-form-item label="银联支付开发者ID" prop="unionAppId" v-if="form.unionPayEnabled === 1">
          <el-input v-model="form.unionAppId" placeholder="请输入银联支付开发者ID" />
        </el-form-item>
        <el-form-item label="银联支付开发者密钥" prop="unionAppKey" v-if="form.unionPayEnabled === 1">
          <el-input v-model="form.unionAppKey" type="password" placeholder="请输入银联支付开发者密钥" show-password />
        </el-form-item>
        <el-form-item label="银联支付商户号" prop="unionMid" v-if="form.unionPayEnabled === 1">
          <el-input v-model="form.unionMid" placeholder="请输入银联支付商户号" />
        </el-form-item>
        <el-form-item label="银联支付终端号" prop="unionTid" v-if="form.unionPayEnabled === 1">
          <el-input v-model="form.unionTid" placeholder="请输入银联支付终端号" />
        </el-form-item>
        <el-form-item label="银联支付子商户号" prop="unionSubMid" v-if="form.unionPayEnabled === 1">
          <el-input v-model="form.unionSubMid" placeholder="请输入银联支付子商户号（运营商账户）" />
        </el-form-item>
        <el-form-item label="银联支付业务类型" prop="unionInstMid" v-if="form.unionPayEnabled === 1">
          <el-input v-model="form.unionInstMid" placeholder="请输入银联支付业务类型" />
        </el-form-item>
        <el-form-item label="银联支付回调地址" prop="unionNotifyUrl" v-if="form.unionPayEnabled === 1">
          <el-input v-model="form.unionNotifyUrl" placeholder="请输入银联支付回调地址" />
        </el-form-item>
        <el-form-item label="银联支付退款回调地址" prop="unionRefundUrl" v-if="form.unionPayEnabled === 1">
          <el-input v-model="form.unionRefundUrl" placeholder="请输入银联支付退款回调地址" />
        </el-form-item>

        <!-- 其他配置 -->
        <el-divider content-position="left">其他配置</el-divider>
        
        <el-form-item label="是否启用微信分账" prop="isActive">
            <el-radio-group v-model="form.isActive">
              <el-radio :label="1">启用</el-radio>
              <el-radio :label="0">未启用</el-radio>
            </el-radio-group>
        </el-form-item>
        <el-form-item label="是否默认" prop="isDefault">
            <el-radio-group v-model="form.isDefault">
              <el-radio :label="1">是</el-radio>
              <el-radio :label="0">否</el-radio>
            </el-radio-group>
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button @click="cancel">取 消</el-button>
        <el-button type="primary" @click="submitForm" style="background-color: #3CA757; border-color: #3CA757;">确 定</el-button>
      </div>
    </el-dialog>

    <!-- 商户支付配置详情对话框 -->
    <el-dialog title="商户支付配置详情" :visible.sync="detailOpen" width="750px" append-to-body>
      <el-descriptions :column="2" border v-if="detailForm">
        <el-descriptions-item label="运营商ID" :span="2">{{ detailForm.distributorId }}</el-descriptions-item>
        <el-descriptions-item label="运营商名称" :span="2">{{ detailForm.distributorName }}</el-descriptions-item>
        
        <el-descriptions-item label="微信小程序AppID">{{ detailForm.appId || '-' }}</el-descriptions-item>
        <el-descriptions-item label="微信支付商户号">{{ detailForm.mchId || '-' }}</el-descriptions-item>
        <el-descriptions-item label="微信支付密钥地址">{{ detailForm.privateKeyFromPath ? '已配置' : '-' }}</el-descriptions-item>
        <el-descriptions-item label="微信支付证书序列号">{{ detailForm.merchantSerialNumber || '-' }}</el-descriptions-item>
        <el-descriptions-item label="微信支付证书路径">{{ detailForm.certPath ? '已配置' : '-' }}</el-descriptions-item>
        <el-descriptions-item label="微信支付回调地址">{{ detailForm.notifyUrl || '-' }}</el-descriptions-item>
        <el-descriptions-item label="微信退款回调地址">{{ detailForm.refundUrl || '-' }}</el-descriptions-item>
        <el-descriptions-item label="APIv3密钥">{{ detailForm.apiV3Key ? '******' : '-' }}</el-descriptions-item>
        <el-descriptions-item label="APIv2密钥">{{ detailForm.apiV2Key ? '******' : '-' }}</el-descriptions-item>
        <el-descriptions-item label="支付分服务ID">{{ detailForm.wechatPayScoreServiceId || '-' }}</el-descriptions-item>
        
        <el-descriptions-item label="是否启用银联支付">
          <span :style="{ color: detailForm.unionPayEnabled === 1 ? '#67C23A' : '#909399' }">{{ detailForm.unionPayEnabled === 1 ? '是' : '否' }}</span>
        </el-descriptions-item>
        <el-descriptions-item label="银联支付开发者ID" v-if="detailForm.unionPayEnabled === 1">{{ detailForm.unionAppId || '-' }}</el-descriptions-item>
        <el-descriptions-item label="银联支付开发者密钥" v-if="detailForm.unionPayEnabled === 1">{{ detailForm.unionAppKey ? '******' : '-' }}</el-descriptions-item>
        <el-descriptions-item label="银联支付商户号" v-if="detailForm.unionPayEnabled === 1">{{ detailForm.unionMid || '-' }}</el-descriptions-item>
        <el-descriptions-item label="银联支付终端号" v-if="detailForm.unionPayEnabled === 1">{{ detailForm.unionTid || '-' }}</el-descriptions-item>
        <el-descriptions-item label="银联支付子商户号" v-if="detailForm.unionPayEnabled === 1">{{ detailForm.unionSubMid || '-' }}</el-descriptions-item>
        <el-descriptions-item label="银联支付业务类型" v-if="detailForm.unionPayEnabled === 1">{{ detailForm.unionInstMid || '-' }}</el-descriptions-item>
        <el-descriptions-item label="银联支付回调地址" v-if="detailForm.unionPayEnabled === 1">{{ detailForm.unionNotifyUrl || '-' }}</el-descriptions-item>
        <el-descriptions-item label="是否启用微信分账">
          <span :style="{ color: detailForm.isActive === 1 ? '#67C23A' : '#F56C6C' }">{{ detailForm.isActive === 1 ? '是' : '否' }}</span>
        </el-descriptions-item>
        <el-descriptions-item label="是否默认">
          <span :style="{ color: detailForm.isDefault === 1 ? '#67C23A' : '#F56C6C' }">{{ detailForm.isDefault === 1 ? '是' : '否' }}</span>
        </el-descriptions-item>
        <el-descriptions-item label="创建时间" :span="2">{{ detailForm.createTime }}</el-descriptions-item>
        <el-descriptions-item label="更新时间" :span="2">{{ detailForm.updateTime }}</el-descriptions-item>
      </el-descriptions>
      <div slot="footer" class="dialog-footer">
        <el-button @click="detailOpen = false">关 闭</el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>


export default {
  name: "MerchantPaymentConfigManage",
  data() {
    return {
      // 遮罩层
      loading: true,
      // 选中数组
      ids: [],
      // 非单个禁用
      single: true,
      // 非多个禁用
      multiple: true,
      // 显示搜索条件
      showSearch: true,
      // 总条数
      total: 0,
      // 商户支付配置表格数据
      merchantPaymentConfigList: [],
      // 弹出层标题
      title: "",
      // 是否显示弹出层
      open: false,
      // 是否显示详情弹出层
      detailOpen: false,
      // 查询参数
      queryParams: {
        page: 1,
        limit: 10,
        distributorId: null,
        distributorName: null,
        isActive: null,
        isDefault: null,
      },
      // 表单参数
      form: {},
      // 详情表单参数
      detailForm: {},
      // 表单校验
      rules: {
        distributorId: [
          { required: true, message: "运营商不能为空", trigger: "change" }
        ],
        appId: [
          { required: true, message: "微信小程序AppID不能为空", trigger: "blur" }
        ],
        mchId: [
          { required: true, message: "微信支付商户号不能为空", trigger: "blur" }
        ],
        privateKeyFromPath: [
          { required: true, message: "微信支付密钥地址不能为空", trigger: "blur" }
        ],
        merchantSerialNumber: [
          { required: true, message: "微信支付证书序列号不能为空", trigger: "blur" }
        ],
        apiV3Key: [
          { required: true, message: "APIv3密钥不能为空", trigger: "blur" }
        ],
        isActive: [
          { required: true, message: "是否启用微信分账不能为空", trigger: "change" }
        ],
        isDefault: [
          { required: true, message: "是否默认不能为空", trigger: "change" }
        ]
      },
      // 运营商列表数据
      distributorList: [],
      // 服务商配置列表
      spConfigList: [],
      // 静态字典数据
      sysYesNoDict: [
        { label: '是', value: 1 },
        { label: '否', value: 0 }
      ]
    };
  },
  created() {
    this.initCurrentRoleCode();
    this.getList();
    this.getDistributorList();
    this.getSpConfigList();
  },
  methods: {
    initCurrentRoleCode() {
      const roleCodes = JSON.parse(window.sessionStorage.getItem('roleCodes') || '[]');
      const roles = JSON.parse(window.sessionStorage.getItem('roles') || '[]');
      this.isSuperAuthority = roleCodes.includes('SUPER_AUTHORITY') || roles.some(role => role.roleCode === 'SUPER_AUTHORITY');
    },
    /** 查询商户支付配置列表 */
    getList() {
      this.loading = true;
      this.$http.post('/merchant/payment/config/list', this.queryParams).then(response => {
        if (response.data.code === 200) {
          this.merchantPaymentConfigList = response.data.data.list;
          this.total = response.data.data.total;
        } else {
          this.$message.error(response.data.msg || '获取数据失败');
        }
        this.loading = false;
      }).catch(error => {
        this.loading = false;
        this.$message.error('获取数据失败');
      });
    },
    // 取消按钮
    cancel() {
      this.open = false;
      this.reset();
    },
    // 表单重置
    reset() {
      this.form = {
        id: null,
        distributorId: null,
        distributorName: null,
        appId: null,
        mchId: null,
        privateKeyFromPath: null,
        merchantSerialNumber: null,
        certPath: null,
        notifyUrl: null,
        refundUrl: null,
        apiV3Key: null,
        apiV2Key: null,
        wechatPayScoreServiceId: null,
        defaultPaymentChannel: 1,
        unionAppId: null,
        unionAppKey: null,
        unionMid: null,
        unionTid: null,
        unionSubMid: null,
        unionInstMid: 'MINIDEFAULT',
        unionNotifyUrl: null,
        unionRefundUrl: null,
        unionPayEnabled: 0,
        alipayAesKey: null,
        alipaySubMchId: null,
        alipayNotifyUrl: null,
        alipayRefundUrl: null,
        alipayPayEnabled: 0,
        isActive: 1,
        isDefault: 0,
        spConfigId: null
      };
      // 重置表单验证
      if (this.$refs.form) {
        this.$refs.form.clearValidate();
      }
    },
    /** 搜索按钮操作 */
    handleQuery() {
      this.queryParams.page = 1;
      this.getList();
    },
    // 多选框选中数据
    handleSelectionChange(selection) {
      this.ids = selection.map(item => item.id)
      this.single = selection.length!==1
      this.multiple = !selection.length
    },
    /** 新增按钮操作 */
    handleAdd() {
      this.reset();
      this.open = true;
      this.title = "添加商户支付配置";
    },
    /** 查询子商户最大分账比例 */
    handleQuerySplitRatio(row) {
      this.$http.get('/wxPay/api/wxPay/queryMaxSplitRatio', {
        params: { distributorId: row.distributorId }
      }).then(response => {
        if (response.data.code === 200) {
          let ratioText = '未获取到';
          let rawRatio = '';
          let subMchid = '';
          const rawData = response.data.data;
          if (rawData) {
            try {
              const parsed = typeof rawData === 'string' ? JSON.parse(rawData) : rawData;
              if (parsed && parsed.max_ratio != null) {
                // 微信返回的 max_ratio 单位是万分比，1000 = 10%
                const ratioValue = Number(parsed.max_ratio) / 10000;
                ratioText = (ratioValue * 100).toFixed(2) + '%';
                rawRatio = parsed.max_ratio;
              }
              if (parsed && parsed.sub_mchid) {
                subMchid = parsed.sub_mchid;
              }
            } catch (e) {
              ratioText = rawData;
            }
          }
          this.$alert(
            `<div style="line-height:1.8">
              <div><b>运营商：</b>${row.distributorName || '-'}</div>
              <div><b>子商户号：</b>${subMchid || row.mchId || '-'}</div>
              <div><b>最大分账比例：</b><span style="color:#E6A23C;font-weight:bold">${ratioText}</span>${rawRatio ? ` <span style="color:#909399;font-size:12px">(原始值: ${rawRatio}，单位: 万分比)</span>` : ''}</div>
              <div style="margin-top:8px;color:#909399;font-size:12px">说明：该比例由子商户在微信商户平台手动设置，服务商无法通过API修改。设置路径：子商户登录商户平台 → 产品中心 → 授权的产品 → 分账授权。</div>
            </div>`,
            '子商户最大分账比例',
            { dangerouslyUseHTMLString: true, confirmButtonText: '知道了' }
          );
        } else {
          this.$message.error(response.data.msg || '查询失败');
        }
      }).catch(() => {
        this.$message.error('请求失败，请稍后重试');
      });
    },
    /** 修改按钮操作 */
    handleUpdate(row) {
      this.reset();
      const id = row.id || this.ids;
      this.$http.get('/merchant/payment/config/' + id).then(response => {
        if (response.data.code === 200) {
          // 直接使用后端返回的数据，不再进行转换
          this.form = response.data.data;
          // 确保默认值存在
          if (this.form.unionPayEnabled == null) {
            this.form.unionPayEnabled = 0;
          }
          if (this.form.defaultPaymentChannel == null) {
            this.form.defaultPaymentChannel = 1;
          }
          if (this.form.unionInstMid == null) {
            this.form.unionInstMid = 'MINIDEFAULT';
          }
          this.open = true;
          this.title = "修改商户支付配置";
        } else {
          this.$message.error(response.data.msg || '获取数据失败');
        }
      }).catch(error => {
        this.$message.error('获取数据失败');
      });
    },
    /** 详情按钮操作 */
    handleDetail(row) {
      this.detailForm = row;
      this.detailOpen = true;
    },
    /** 提交按钮 */
    submitForm() {
      this.$refs["form"].validate(valid => {
        if (valid) {
          // 确保distributorName字段已设置
          if (this.form.distributorId && !this.form.distributorName) {
            const selectedDistributor = this.distributorList.find(item => item.id === this.form.distributorId);
            if (selectedDistributor) {
              this.form.distributorName = selectedDistributor.name;
            }
          }
          
          // 如果未启用银联支付，清空相关字段
          if (this.form.unionPayEnabled !== 1) {
            this.form.unionAppId = null;
            this.form.unionAppKey = null;
            this.form.unionMid = null;
            this.form.unionTid = null;
            this.form.unionSubMid = null;
            this.form.unionNotifyUrl = null;
            this.form.unionRefundUrl = null;
          }
          
          // 创建提交数据副本，确保所有字段都被包含
          const submitData = {
            id: this.form.id,
            distributorId: this.form.distributorId,
            distributorName: this.form.distributorName,
            appId: this.form.appId,
            mchId: this.form.mchId,
            privateKeyFromPath: this.form.privateKeyFromPath,
            merchantSerialNumber: this.form.merchantSerialNumber,
            certPath: this.form.certPath,
            notifyUrl: this.form.notifyUrl,
            refundUrl: this.form.refundUrl,
            apiV3Key: this.form.apiV3Key,
            apiV2Key: this.form.apiV2Key,
            wechatPayScoreServiceId: this.form.wechatPayScoreServiceId,
            defaultPaymentChannel: this.form.defaultPaymentChannel,
            unionAppId: this.form.unionAppId,
            unionAppKey: this.form.unionAppKey,
            unionMid: this.form.unionMid,
            unionTid: this.form.unionTid,
            unionSubMid: this.form.unionSubMid,
            unionInstMid: this.form.unionInstMid,
            unionNotifyUrl: this.form.unionNotifyUrl,
            unionRefundUrl: this.form.unionRefundUrl,
            unionPayEnabled: this.form.unionPayEnabled,
            isActive: this.form.isActive,
            isDefault: this.form.isDefault,
            spConfigId: this.form.spConfigId
          };
          
          // 打印提交数据，用于调试
          console.log('提交数据:', submitData);
          
          if (this.form.id != null) {
            // 更新操作 - 使用新的更新接口
            this.$http.post('/merchant/payment/config/update', submitData).then(response => {
              if (response.data.code === 200) {
                this.$message.success("修改成功");
                this.open = false;
                this.getList();
              } else {
                this.$message.error(response.data.msg || '修改失败');
              }
            }).catch(error => {
              console.error('更新失败:', error);
              this.$message.error('修改失败');
            });
          } else {
            // 新增操作 - 移除id字段，使用新的新增接口
            const { id, ...newSubmitData } = submitData;
            console.log('新增数据:', newSubmitData);
            this.$http.post('/merchant/payment/config/add', newSubmitData).then(response => {
              if (response.data.code === 200) {
                this.$message.success("新增成功");
                this.open = false;
                this.getList();
              } else {
                this.$message.error(response.data.msg || '新增失败');
              }
            }).catch(error => {
              console.error('新增失败:', error);
              this.$message.error('新增失败');
            });
          }
        }
      });
    },
    /** 删除按钮操作 */
    handleDelete(row) {
      const ids = row.id || this.ids;
      this.$confirm('是否确认删除运营商为"' + row.distributorName + '"的数据项？', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        return this.$http.get('/merchant/payment/config/delete/' + ids);
      }).then(response => {
        if (response.data.code === 200) {
          this.getList();
          this.$message.success("删除成功");
        } else {
          this.$message.error(response.data.msg || '删除失败');
        }
      }).catch(error => {
        this.$message.error('删除失败');
      });
    },
    /** 导出按钮操作 */
    handleExport() {
      this.$http.get('/merchant/payment/config/export', { 
        params: this.queryParams,
        responseType: 'blob'
      }).then(response => {
        const blob = new Blob([response.data], { type: 'application/vnd.ms-excel' });
        const url = window.URL.createObjectURL(blob);
        const link = document.createElement('a');
        link.href = url;
        link.download = `商户支付配置_${new Date().getTime()}.xlsx`;
        link.click();
        window.URL.revokeObjectURL(url);
      }).catch(error => {
        this.$message.error('导出失败');
      });
    },
    // 分页
    handleSizeChange(val) {
      this.queryParams.limit = val;
      this.getList();
    },
    handleCurrentChange(val) {
      this.queryParams.page = val;
      this.getList();
    },
    // 获取运营商列表
    getDistributorList() {
      this.$http.get('/distributor/manager/getAllDistributorInfo').then(response => {
        if (response.data.code === 200) {
          this.distributorList = response.data.data;
        } else {
          this.$message.error(response.data.msg || '获取运营商列表失败');
        }
      }).catch(error => {
        this.$message.error('获取运营商列表失败');
      });
    },
    // 处理查询表单运营商选择变化
    handleDistributorChange(value) {
      this.queryParams.distributorId = value;
      // 根据选择的运营商ID获取运营商名称
      const selectedDistributor = this.distributorList.find(item => item.id === value);
      if (selectedDistributor) {
        this.queryParams.distributorName = selectedDistributor.name;
      }
    },
    // 处理表单运营商选择变化
    handleFormDistributorChange(value) {
      this.form.distributorId = value;
      // 根据选择的运营商ID获取运营商名称
      const selectedDistributor = this.distributorList.find(item => item.id === value);
      if (selectedDistributor) {
        this.form.distributorName = selectedDistributor.name;
      }
    },
    // 关闭对话框
    handleDialogClose() {
      this.reset();
    },
    // 银联支付启用/禁用切换
    handleUnionPayChange(val) {
      if (val !== 1) {
        // 禁用银联，清空相关配置
        this.form.unionAppId = null;
        this.form.unionAppKey = null;
        this.form.unionMid = null;
        this.form.unionTid = null;
        this.form.unionSubMid = null;
        this.form.unionInstMid = null;
        this.form.unionNotifyUrl = null;
        this.form.unionRefundUrl = null;
      }
    },
    // 获取服务商配置列表
    getSpConfigList() {
      this.$http.get('/sp/payment/config/list').then(response => {
        if (response.data.code === 200) {
          this.spConfigList = response.data.data;
        }
      }).catch(() => {});
    }
  }
};
</script>
